import { render, staticRenderFns } from "./InrsDelete.vue?vue&type=template&id=4718f814&"
import script from "./InrsDelete.vue?vue&type=script&lang=js&"
export * from "./InrsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports